import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaOptimizationBuyOrRentFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        propertyType: this.entity.propertyType ? entity.propertyType : null,
        estimation: this.entity.estimation ? entity.estimation : null,
        areaSize: this.entity.areaSize ? entity.areaSize : null,
        priceAvg: this.entity.priceAvg ? entity.priceAvg : null,
        rent: this.entity.rent ? entity.rent : null,
        duration: this.entity.rent ? entity.duration : null,
        rentalReversion: this.entity.rentalReversion
          ? this.formatNumber(entity.rentalReversion * 100)
          : null,
        loanDuration: this.entity.loanDuration ? entity.loanDuration : null,
        loanInterestRate: this.entity.loanInterestRate
          ? this.formatNumber(entity.loanInterestRate * 100)
          : null,
        loanInsuranceRate: this.entity.loanInsuranceRate
          ? this.formatNumber(entity.loanInsuranceRate * 100)
          : null,
        agencyFees: this.entity.agencyFees
          ? this.formatNumber(entity.agencyFees * 100)
          : null,
        notaryFees: this.entity.notaryFees
          ? this.formatNumber(entity.notaryFees * 100)
          : null,
        managementFees: this.entity.managementFees
          ? entity.managementFees
          : null,
        propertyTax: this.entity.propertyTax ? entity.propertyTax : null,
      },
      options,
    );
  }

  formatNumber(value: number) {
    return Math.round(value * 100) / 100;
  }

  extract() {
    return {
      parameters: {
        propertyType: this.emptyIsNull(this.form.value.propertyType),
        estimation: this.emptyIsNull(this.form.value.estimation),
        areaSize: this.emptyIsNull(this.form.value.areaSize),
        priceAvg: this.emptyIsNull(this.form.value.priceAvg),
        rent: this.emptyIsNull(this.form.value.rent),
        duration: this.emptyIsNull(this.form.value.duration),
        loanDuration: this.emptyIsNull(this.form.value.loanDuration),
        loanInterestRate: this.emptyIsNull(
          this.form.value.loanInterestRate / 100,
        ),
        loanInsuranceRate: this.emptyIsNull(
          this.form.value.loanInsuranceRate / 100,
        ),
        rentalReversion: this.emptyIsNull(
          this.form.value.rentalReversion / 100,
        ),
        agencyFees: this.emptyIsNull(this.form.value.agencyFees / 100),
        notaryFees: this.emptyIsNull(this.form.value.notaryFees / 100),
        managementFees: this.emptyIsNull(this.form.value.managementFees),
        propertyTax: this.emptyIsNull(this.form.value.propertyTax),
      },
    };
  }
}
